import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/layout';
import { api } from '../services/api';

// Каталог сервисов с кодами пополнения. Spotify и Brawl Stars временно убраны:
// у поставщика Spotify весь распродан (inStock 0 во всех странах), Brawl Stars
// в каталоге отсутствует вовсе. PlayStation — карты пополнения PSN
// (существующие подборки topup-*), остальные — через поставщика AppRoute:
// сервис кликабелен, когда его позиции есть в наличии; иначе «Скоро».
export const CODE_SERVICES: Array<{ key: string; name: string; logo: string }> = [
  { key: 'playstation', name: 'PlayStation', logo: '/services/logo-psstore.webp' },
  { key: 'apple', name: 'Apple', logo: '/services/logo-apple.webp' },
  { key: 'nintendo', name: 'Nintendo', logo: '/services/logo-nintendo.webp' },
  { key: 'roblox', name: 'Roblox', logo: '/services/logo-roblox.webp' },
  { key: 'gplay', name: 'Google Play', logo: '/services/logo-gplay.webp' },
  { key: 'valorant', name: 'Valorant', logo: '/services/logo-valorant.webp' },
  { key: 'blizzard', name: 'Blizzard', logo: '/services/logo-blizzard.webp' },
  { key: 'fortnite', name: 'Fortnite', logo: '/services/logo-fortnite.webp' },
];

/** Куда ведет плитка сервиса: у всех — своя страница номиналов. */
export const codeServicePath = (key: string): string => `/codes/${key}`;

export const CodesPage: React.FC = () => {
  const navigate = useNavigate();
  const [availableKeys, setAvailableKeys] = useState<Set<string>>(new Set());
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.getCodeServices()
      .then((r) => setAvailableKeys(new Set(r.services.map((s) => s.key))))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const isAvailable = (key: string) => availableKeys.has(key);

  const handleSelect = (key: string) => {
    if (!isAvailable(key)) return;
    navigate(codeServicePath(key));
  };

  return (
    <Layout>
      <div className="flex flex-col min-h-full" style={{ background: '#F5F7FA' }}>
        <div className="px-4 pt-4 pb-1">
          <h1 className="text-[17px] font-bold text-text-primary">Коды пополнения</h1>
          <p className="text-[13px] text-text-secondary mt-0.5">
            Выберите сервис — код придет сразу после оплаты
          </p>
        </div>

        <div className="px-4 pt-3 pb-6 grid grid-cols-4" style={{ gap: '14px 10px' }}>
          {CODE_SERVICES.map((s) => {
            const available = isAvailable(s.key);
            // Пока витрина не загрузилась — не гасим иконки: иначе на старте
            // все сервисы мигают серым и только потом становятся цветными
            const dimmed = loaded && !available;
            return (
              <button
                key={s.key}
                onClick={() => handleSelect(s.key)}
                className={`flex flex-col text-center ${available ? 'active:scale-[0.95] transition-transform' : 'cursor-default'}`}
                style={{ gap: '7px' }}
              >
                <img
                  src={s.logo}
                  alt={s.name}
                  className="w-full rounded-[18px]"
                  loading="eager"
                  decoding="sync"
                  style={{ aspectRatio: '1', objectFit: 'cover', opacity: dimmed ? 0.55 : 1 }}
                />
                <span
                  className="leading-tight"
                  style={{ fontSize: '11.5px', fontWeight: 500, color: dimmed ? '#8B8E97' : '#33415C' }}
                >
                  {s.name}
                  {dimmed && (
                    <>
                      <br />
                      <span style={{ fontSize: '10px', color: '#B0B3BA' }}>Скоро</span>
                    </>
                  )}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};
